import { apiS3FileIdToUrl } from '#/api/s3File/apiS3FileIdToUrl';
import { Button } from '#/components/Button/Button';
import { Icon } from '#/components/Icon/Icon';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { DatetimeString } from '#/types/TypedDateString';
import { legacy_shortDate_yearFormat_long_space_humanTime } from '#/utils/date';

import {
  SmallFilePickerFilenameBody,
  SmallFilePickerFilenameLastUpdated,
  SmallFilePickerFilenameText,
} from './SmallFilePickerFilename.styled';

type Props = {
  fileId: string;
  qaId: string;
  downloadAttachment: boolean;
  filename: string | null;
  onRemove: (() => void) | null;
  created: DatetimeString | null;
  disabled: boolean;
};

export function SmallFilePickerFilename({
  fileId,
  qaId,
  downloadAttachment,
  filename,
  onRemove,
  created,
  disabled,
}: Props) {
  const { i18n, locale } = useI18n();

  return (
    <div data-qa-id={`${qaId}-preview`}>
      <SmallFilePickerFilenameBody>
        <a
          title={
            downloadAttachment ? i18n('Download') : i18n('Open in new window')
          }
          href={apiS3FileIdToUrl({ fileId, downloadAttachment })}
          target="_blank"
          onClick={(e) => {
            e.stopPropagation();
          }}
          rel="noopener noreferrer"
        >
          <SmallFilePickerFilenameText>{filename}</SmallFilePickerFilenameText>
        </a>

        {onRemove && !disabled && (
          <Button
            type="button"
            variant="link-danger"
            noPadding
            title={
              /* TRANSLATORS: Remove file upload */
              i18n('Remove file %(filename)s', { filename: filename ?? '' })
            }
            qaId={`${qaId}-delete`}
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
          >
            <Icon name="close" size={16} />
          </Button>
        )}
      </SmallFilePickerFilenameBody>

      {created && (
        <SmallFilePickerFilenameLastUpdated data-qa-id={`${qaId}-upload-date`}>
          {i18n('Last updated: %(date)s', {
            date: legacy_shortDate_yearFormat_long_space_humanTime({
              date: created,
              locale,
            }),
          })}
        </SmallFilePickerFilenameLastUpdated>
      )}
    </div>
  );
}
